var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCnh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 22.5C37 30.5081 30.5081 37 22.5 37C14.4919 37 8 30.5081 8 22.5C8 14.4919 14.4919 8 22.5 8C30.5081 8 37 14.4919 37 22.5ZM20.6875 33.2246V32.1666L20.3663 29.9182C19.8394 26.23 16.9614 23.3209 13.2791 22.7544L11.625 22.4999C11.625 27.8885 15.5441 32.3617 20.6875 33.2246ZM12.0501 19.4791C13.3591 14.9427 17.5421 11.625 22.5 11.625C27.4579 11.625 31.6409 14.9427 32.9499 19.4791H12.0501ZM33.375 22.4999L31.7209 22.7544C28.0386 23.3209 25.1606 26.23 24.6337 29.9182L24.3125 32.1666V33.2246C29.4559 32.3617 33.375 27.8885 33.375 22.4999Z",
    stroke: "#0F90FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnh);
export default __webpack_public_path__ + "static/media/cnh.d9b9fd3f2ce1114a94c2fbc96d7f52cf.svg";
export { ForwardRef as ReactComponent };